import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MetaPreviewData } from '../../../../../../../models/meta-template/preview-interfaces/meta-preview-data.interface';
import { MetaCreativeComponent } from '../../../preview-common/meta-creative/meta-creative.component';
import { MetaPreviewCopy } from '../../../preview-common/meta-preview-copy';

/** Instagram Stories on mobile ("Instagram Stories za mobilne uređaje"). */
@Component({
  selector: 'app-meta-instagram-stories-mobile',
  imports: [CommonModule, MetaCreativeComponent],
  templateUrl: './instagram-stories-mobile.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [
    '../../../preview-common/story/meta-story-styles.scss',
    './instagram-stories-mobile.component.scss',
  ]
})
export class MetaInstagramStoriesMobilePreviewComponent {
  @Input() data!: MetaPreviewData;

  readonly accountName = MetaPreviewCopy.INSTAGRAM_ACCOUNT_NAME;
  readonly avatar = MetaPreviewCopy.AVATAR;

  get cta(): string {
    return MetaPreviewCopy.cta(this.data);
  }
}
